import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import {SanitizeHtmlPipe} from '../../../helpers/sanitize-html-pipe';

@Component({
  selector: 'app-html-modal',
  templateUrl: './html-modal.component.html',
  styleUrls: ['./html-modal.component.scss']
})
export class HtmlModalComponent {
  @Input() public title: string;
  @Input() public content: string;

  constructor(
    protected modalController: ModalController
  ) {
  }

  public dismiss(): void {
    this.modalController.dismiss({
      'dismissed': true
    });
  }

}
